const FromArrEditor = [{
		key: 'InvClass',
		modelvalue: undefined,
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 20,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	},
	{
		key: 'CusCode',
		title: "经销商：",
		inputtype: "selectSingle",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		loading: false,
		remoteMethod: 'CusCode',
	}, {
		key: 'MFCode',
		modelvalue: undefined,
		title: "生产厂商：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	},
	{
		key: 'Hospital',
		title: "医院：",
		inputtype: "selectSingle",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 34,
		marginTop: 26,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		loading: false,
		remoteMethod: 'Hospital',
	}, {
		key: 'Doctor',
		title: "试用医生：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 198,
		height: 32,
		disabled: false,
		marginLeft: 48,
		marginTop: 18,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		key: 'Purpose',
		title: "用途：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 198,
		height: 32,
		disabled: false,
		marginLeft: 86,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		key: 'DeliveryAddress',
		title: "收货地址：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 6,
		marginTop: 12,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		key: 'SampleType',
		modelvalue: null,
		title: "样品类型：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 46,
		marginTop: 18,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	},
	{
		key: 'SalerInCharge',
		title: "负责销售：",
		inputtype: "selectSingle",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 58,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		loading: false,
		remoteMethod: 'SalerInCharge',
		hidden: true,
	}, {
		key: 'AdvType',
		modelvalue: undefined,
		title: "分类：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 212,
		height: 32,
		disabled: false,
		marginLeft: 86,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		hidden: true,
	}, {
		key: 'Activity',
		title: "活动：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 86,
		marginTop: 12,
		displayVal: "inline-block",
		fontWeightVal: 500,
		hidden: true,
	}
];
export default FromArrEditor;